import { Component, computed, EventEmitter, input, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormValidationComponent } from './form-validation/form-validation.component';
import { DxButtonModule, DxTextAreaModule, DxValidatorModule } from 'devextreme-angular';
import { sign } from 'crypto';

@Component({
    selector: 'form-text-area',
    imports: [CommonModule, DxTextAreaModule, DxValidatorModule],
    template: `
    <dx-text-area
      stylingMode="filled"
      valueChangeEvent="keyup input change"
      [label]="label"
      [(value)]="value"
      [readOnly]="!isEditing"
      [height]="height()"
      [elementAttr]="{ class: 'form-editor' }"
      [inputAttr]="{ class: 'form-editor-input' }"
      (onValueChanged)="valueChanged($event)"
    >
      <dx-validator [validationRules]="validationRules()"></dx-validator>
    </dx-text-area>
  `,
    styles: []
})
export class FormTextAreaComponent extends FormValidationComponent {
  @Input() isEditing = false;
  @Input() label = '';
  @Input() value!: string;
  @Output() valueChange = new EventEmitter<string>();

  height = input<string>('');

  valueChanged(e) {
    this.valueChange.emit(e.value);
  }
}
